import React, { useEffect, useRef, useState } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import Verification from "./Verification.jsx";
import { api } from "./api.js";
import "./styles.css";
import "./system-v2.css";

function RateLimitGate({ children }) {
  const [access, setAccess] = useState({ loading: true, required: false, challenge: null, visitCount: 0, maxVisits: 5, error: "" });
  const visitRecorded = useRef(false);

  useEffect(() => {
    if (visitRecorded.current) return;
    visitRecorded.current = true;
    api.recordVisit().then(result => {
      setAccess({ loading: false, error: "", ...result });
    }).catch(error => {
      setAccess(current => ({ ...current, loading: false, error: error.message }));
    });
  }, []);

  const handleVerified = () => setAccess(current => ({ ...current, required: false, verified: true }));

  if (access.loading) return <div className="boot-screen"><span className="boot-mark">⚡</span><strong>华能智维电力</strong><p>正在进行安全检查…</p></div>;

  if (access.error) {
    return <div className="boot-screen boot-error"><span className="boot-mark">!</span><strong>系统服务暂不可用</strong><p>{access.error}</p><button onClick={() => window.location.reload()}>重新连接</button></div>;
  }

  if (access.required) {
    return <Verification onVerified={handleVerified} visitCount={access.visitCount} maxVisits={access.maxVisits} initialChallenge={access.challenge} />;
  }

  return children;
}

const rootElement = document.getElementById("root");
const root = globalThis.__HNZW_REACT_ROOT__ || createRoot(rootElement);
if (import.meta.env.DEV) globalThis.__HNZW_REACT_ROOT__ = root;

root.render(
  <React.StrictMode>
    <RateLimitGate>
      <App />
    </RateLimitGate>
  </React.StrictMode>
);
